mainApp.component('iconUploader', {
    templateUrl: '/public/components/cloudAccess/icon-uploader.component.html',
	bindings: {
        onHasChanges: '&',// will be triggered when icon is uploaded \ deleted and save button should be enabled
        existingFile: '<',
        imageType: '<'
	},
	controller: iconUploaderController
});

//listens to:
//'modelReloadedEvent' - to know when parent model was reloaded (different application was selected for example) to reload correct icon

function iconUploaderController($scope, Upload, ImageService) {
    const ctrl = this;
    const MAX_FILE_IN_BYTES = 200*1024;

    ctrl.$onInit = function() {
        reload();
    };

    function reload() {
        if(ctrl.existingFile) {
            ctrl.imageToPreviewBase64 = ImageService.getImageTextForSrc(ctrl.existingFile, ctrl.imageType);
        }
        else{
            ctrl.imageToPreviewBase64 = null;
        }
    }

    ctrl.handleUploadedFile = function(file){
        if(!file){
            return;
        }
        if( file.size > MAX_FILE_IN_BYTES) {
            $scope.$root.showNotification("error", "Image file must be smaller than 200KB");
        }
        else {
            showUploadedImage(file);
        }
    };

    function showUploadedImage(file) {
        ImageService.getBase64(file).then(function (data) {
            if(!angular.equals(ctrl.imageToPreviewBase64, data)) {
                ctrl.imageToPreviewBase64 = data;
                let imageText = data.split(",")[1];
                let imageType = ctrl.currentFile.type.replace("image/", "");
                ctrl.onHasChanges({imageText: imageText, imageType: imageType});
            }
        });
    }

    ctrl.deleteIcon = function(){
        ctrl.onHasChanges({imageText: "", imageType:""});
    };


    ctrl.$onChanges = function(changes) {
        if (changes.existingFile) {
            reload();
        }
    };
}